import { Appearance } from './appearanceTypes';
import button from '../../components/core/button/button.light.module.scss';
import card from '../../components/core/card/card.light.module.scss';
import circleButton from '../../components/core/circle-button/circle_button.light.module.scss';
import colors from '../../components/foundation/colors/_color.light.tokens.scss';
import gradients from '../../components/foundation/colors/_gradient.light.tokens.scss';
import link from '../../components/core/link/link.light.module.scss';
import typography from '../../components/foundation/typography/typography.light.module.scss';
import tooltip from '../../components/core/tooltip/tooltip.light.module.scss';


export const light: Appearance = {
  button,
  card,
  circleButton,
  colors,
  gradients,
  link,
  typography,
  tooltip
};
